import { DAYS } from '../../app_constants';

export const date = new Date();

export function getWeekDay(value: Date) {
  return DAYS[value.getDay()];
}

const localeButtonWeatherDate = new Date().toLocaleString('ru', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
});

export const getButtonWeatherDate = () => `${localeButtonWeatherDate}`;

export const formatedDateDayBirdh = (value: string) => {
  return new Date(value).toLocaleDateString('ru');
};

const monthsInGenitiveCase = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const formatedDateRange = (startDateStr: string, endDateStr: string): string => {
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  const startDay = start.getDate();
  const endDay = end.getDate();
  const startMonthIndex = start.getMonth();
  const endMonthIndex = end.getMonth();
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  if (startMonthIndex === endMonthIndex && startYear === endYear) {
    return `${startDay}-${endDay} ${monthsInGenitiveCase[startMonthIndex]}`;
  }
  return `${startDay} ${monthsInGenitiveCase[startMonthIndex]} - ${endDay} ${monthsInGenitiveCase[endMonthIndex]}`;
};

export const formattedDate = (value: string): string => {
  const dater = new Date(value);
  const startDay = dater.getDate();
  const hours = dater.getHours();
  const minutes = dater.getMinutes();
  const roundedMinutes = minutes < 30 ? 0 : 30;
  const padZero = (num: number): string => num.toString().padStart(2, '0');
  const startMonthIndex = dater.getMonth();
  return `${padZero(hours)}:${padZero(roundedMinutes)} ${startDay}
    ${monthsInGenitiveCase[startMonthIndex]}
  `;
};
